import { useMemo } from "react";
import { useStaffWorkspace, useTalentWorkspace } from "../../../app/session";
import { useViewerZone } from "../../../lib/zeitzone";
import { useLang } from "../../creator/sprache";
import type { NotificationScope } from "./data";
import { AgencyChannels, CreatorChannels, NotificationsPage } from "./meldungen";
import { t, ta } from "../../../lib/sprache";

/** Benachrichtigungen des Teams: Meldungen an alle, die den Creator sehen, oder an die Person selbst (0011). */
export function AgenturBenachrichtigungen() {
  const ws = useStaffWorkspace();
  const orgId = ws.org.org_id;
  const scope = useMemo<NotificationScope>(() => ({ orgId, audience: "staff" }), [orgId]);
  const zone = useViewerZone(ws.org.timezone);
  return (
    <NotificationsPage
      portal="agentur"
      scope={scope}
      timeZone={zone}
      eyebrow={ta("Agentur-Arbeitsbereich", "Agency workspace", "Dein Creator-Konto", "Your creator account")}
      counterpart="Creator"
      calendarHref="/agentur/kalender"
      channels={<AgencyChannels orgId={orgId} isChef={ws.isChef} />}
    />
  );
}

/** Benachrichtigungen des Creators: nur die eigenen, nur in der gewählten Agentur. */
export function CreatorBenachrichtigungen() {
  const ws = useTalentWorkspace();
  const orgId = ws.link.org_id;
  const talentId = ws.link.talent_id;
  const scope = useMemo<NotificationScope>(() => ({ orgId, audience: "talent", talentId }), [orgId, talentId]);
  const zone = useViewerZone(ws.org.timezone);
  const lang = useLang();
  return (
    <NotificationsPage
      portal="creator"
      scope={scope}
      timeZone={zone}
      eyebrow={lang === "en" ? "Your creator portal" : "Dein Creator-Portal"}
      counterpart={ws.org.name}
      calendarHref="/creator/kalender"
      channels={<CreatorChannels orgId={orgId} talentId={talentId} timeZone={zone} />}
    />
  );
}
